import { Card, CardContent } from "@/components/ui/card";
import { Phone } from "lucide-react";

export function ContactUsCard() {
  return (
    <Card className="shadow-none">
      <CardContent className="p-6">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <Phone className="h-5 w-5 text-muted-foreground" />
            <h3 className="font-medium">Need Help?</h3>
          </div>

          <div className="grid gap-4">
            <div>
              <div className="text-sm font-medium text-muted-foreground">
                Customer Service
              </div>
              <a
                href="tel:647-931-7960"
                className="mt-1 flex items-center gap-2 text-sm text-blue-600 hover:underline"
              >
                647-931-7960 (English, Chinese)
              </a>
            </div>

            <div className="hidden md:block">
              <div className="text-sm font-medium text-muted-foreground">
                Email Support
              </div>
              <a
                href="mailto:ezexpress.canada@gmail.com"
                className="mt-1 flex items-center gap-2 text-sm text-blue-600 hover:underline"
              >
                ezexpress.canada@gmail.com
              </a>
            </div>

            <div className="hidden md:block">
              <div className="text-sm font-medium text-muted-foreground">
                Hours of Operation
              </div>
              <div className="mt-1 text-sm">
                Monday - Sunday: 12AM - 10PM EST
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
